module.exports = __webpack_public_path__ + "static/img/panbrain.ea0e0b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/panbrain.png
// module id = 5UTW
// module chunks = 1